<template lang="pug">
#solicitar-laudos
    header
        h1 {{ $t('laudos.solicitarLaudoRenovabio') }}

    .territorios
        header.mt-3.mb-3
            h2 {{ $t('laudos.territoriosAdicionados') }}
            BaseButton(
                type='primary',
                size='small',
                icon='el-icon-plus',
                @click='changeShowModalAddTerritorios'
            )
                | {{ $t('laudos.adicionarTerritorio') }}

        main(v-if='Object.keys(territorios).length > 0')
            CardDadosTerritorio.mb-2(
                v-for='(id, index) in Object.keys(territorios)',
                :territorio='territorios[id]',
                :index='index',
                :key='`${territorios[id].nome}_${id}`',
                :valido='cardValido[index]',
                @removerTerritorio='removerTerritorio',
                @getValidacao='setValidacao',
                @getDados='setDados'
            )

        main.sem-territorios(v-else)
            a(@click='changeShowModalAddTerritorios')
                | {{ $t('laudos.adicionarTerritorio') }}

    .acoes
        BaseButton(size='small', @click='$router.go(-1)')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            v-if='Object.keys(territorios).length > 0 && finalizar',
            size='small',
            type='primary',
            icon='el-icon-check',
            @click='solicitarLaudos'
        )
            | {{ $t('mensagens.comuns.finalizar') }}
        BaseButton(
            v-else-if='Object.keys(territorios).length > 0',
            size='small',
            type='primary',
            icon='el-icon-check',
            disabled
        )
            | {{ $t('mensagens.comuns.finalizar') }}

    el-dialog.add-territorio(
        :title='$t("laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos")',
        :visible.sync='showModalAddTerritorios',
        close='changeShowModalAddTerritorios'
    )
        SelecionarTerritorio(
            :selecionados='territoriosSelecionados',
            :tipoLaudoId='tipoLaudoId',
            @getTerritoriosSelecionados='addTerritorios'
        )
    ModalLaudosJaSolicitados(
        :show.sync='mostrarModalCarsJaCadastrados',
        :isTerritorio='isTerritorio',
        :quantidadeCars='quantidadeCARs',
        :carsNovos='carsNovos',
        :infoLaudosParaCadastro='informacaoLaudos',
        @resetProps='resetModalProps',
        @voltarRota='voltarRota'
    )
</template>

<script>
import ModalLaudosJaSolicitados from '@/modules/laudos/components/renovabio/ModalLaudosJaSolicitados.vue';
import CardDadosTerritorio from '@/modules/laudos/components/renovabio/CardDadosTerritorio';
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio';
import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/modules/laudos/services/LaudosService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import formatters from '@/modules/laudos/utils/formatters';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'SolicitarLaudoRenovabio',

    components: {
        ModalLaudosJaSolicitados,
        CardDadosTerritorio,
        SelecionarTerritorio,
        BaseButton
    },

    data() {
        return {
            idsTerritoriosSelecionados: [],
            territoriosSelecionados: [],
            dados: {},
            territorios: {},
            cardValido: {},
            showModalAddTerritorios: false,
            finalizar: false,
            tipoLaudoId: TipoLaudo.RENOVABIO,
            mostrarModalCarsJaCadastrados: false,
            carsSelecionados: [],
            carsNovos: [],
            informacaoLaudos: [],
            isTerritorio: false,
            quantidadeCARs: 0
        };
    },

    mounted() {
        if (this.$route.params.territoriosIdsPesquisaInteligente) {
            this.idsTerritoriosSelecionados =
                this.$route.params.territoriosIdsPesquisaInteligente;
        } else {
            const idsTerritoriosSelecionadosString =
                this.$route.params.idsTerritorio.split('-');
            idsTerritoriosSelecionadosString.pop();

            idsTerritoriosSelecionadosString.forEach(id =>
                this.idsTerritoriosSelecionados.push(parseInt(id))
            );
        }
        this.getTerritorios();
    },

    methods: {
        getTerritorios() {
            const territorios = {
                territoriosIds: this.idsTerritoriosSelecionados
            };

            TerritorioService.solicitacaoLaudo(territorios)
                .then(({ data }) => {
                    this.territorios = {};

                    for (let i = 0; i < data.length; i += 1) {
                        let id = data[i].id;

                        this.territorios[id] = data[i];
                        this.cardValido[id] = this.cardValido[id] || false;
                        this.dados[id] = this.dados[id] || {};
                    }
                });
        },

        removerTerritorio(id) {
            this.idsTerritoriosSelecionados.splice(
                this.idsTerritoriosSelecionados.indexOf(id),
                1
            );

            delete this.territorios[id];
            delete this.cardValido[id];
            delete this.dados[id];

            this.atualizarerritoriosSelecionados();
            this.testeFinalizar();
        },

        changeShowModalAddTerritorios() {
            this.atualizarerritoriosSelecionados();
            this.showModalAddTerritorios = !this.showModalAddTerritorios;
        },

        voltarRota() {
            this.$router.go(-1);
        },

        setValidacao({ valido, id }) {
            this.cardValido[id] = valido;
            this.testeFinalizar();
        },

        testeFinalizar() {
            let finalizar = true;

            for (const id in this.cardValido) {
                if (this.cardValido[id] === false) {
                    finalizar = false;
                    break;
                }
            }

            this.finalizar = finalizar;
        },

        setDados({ dados, id }) {
            this.dados[id] = dados;
        },

        solicitarLaudos() {
            let verificarLaudos = [];
            for (const id in this.cardValido) {
                this.dados[id].forEach(d => {
                    d.cpfCnpjProdutorBiomassa =
                        formatters.removerPontuacaoDocumento(
                            this.$route.params.produtorBiomassa.cpfCnpj
                        );
                    d.nomeRazaoSocialProdutorBiomassa =
                        this.$route.params.produtorBiomassa.nomeRazaoSocial;
                    this.informacaoLaudos.push(d);
                    verificarLaudos.push({
                        car: d.codigoCar,
                        carId: d.carId,
                        territorioId: d.territorioId,
                        cpfCnpjProdutorBiomassa: d.cpfCnpjProdutorBiomassa,
                        nomeRazaoSocialProdutorBiomassa:
                            d.nomeRazaoSocialProdutorBiomassa
                    });
                });
            }

            const tipoLaudoId = TipoLaudo.RENOVABIO;

            LaudosService.verificarLaudosNovos(verificarLaudos, tipoLaudoId)
                .then(response => {
                    const dados = response.data;
                    if (dados.quantidadeDuplicados > 0) {
                        this.carsNovos = dados.cars;
                        this.quantidadeCARs = dados.quantidadeDuplicados;

                        this.abrirModalLaudosJaSolicitados();
                    } else {
                        let informacaoLaudos = this.informacaoLaudos;
                        LaudosService.cadastrarLaudos({ informacaoLaudos })
                            .then(() => {
                                this.$notify.success({
                                    message: this.$t(
                                        'laudos.solicitacaoRealizadaComSucesso'
                                    )
                                });
                                this.$router.go(-1);
                            })
                            .catch(error => {
                                this.$notify.error({
                                    message: error.message
                                });
                            });
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },

        addTerritorios(territorios) {
            this.idsTerritoriosSelecionados = territorios.map(
                territorio => territorio.id
            );
            this.getTerritorios();
            this.changeShowModalAddTerritorios();
        },

        resetModalProps() {
            this.quantidadeCars = 0;
            this.carsNovos = [];
            this.informacaoLaudos = [];
        },

        atualizarerritoriosSelecionados() {
            this.territoriosSelecionados = [];

            for (const id in this.territorios) {
                this.territoriosSelecionados.push(this.territorios[id]);
            }
        },

        abrirModalLaudosJaSolicitados() {
            this.isTerritorio = true;

            this.mostrarModalCarsJaCadastrados = true;
        }
    }
};
</script>

<style lang="scss" scoped>
#solicitar-laudos {
    width: calc(100vw - 115px);
    margin: 15px auto;

    .territorios {
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .sem-territorios {
            display: flex;
            align-items: center;
            justify-content: center;

            height: 400px;

            a {
                text-decoration: underline;
            }

            a:hover {
                cursor: pointer;
            }
        }
    }

    .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
